import * as DG from 'datagrok-api/dg';
export async function getSeqHelper() {
    const packageName = 'Bio';
    const funcList = DG.Func.find({ package: packageName, name: `getSeqHelper` });
    if (funcList.length === 0)
        throw new Error(`Package '${packageName}' must be installed for SeqHelper.`);
    const res = (await funcList[0].prepare().call()).getOutputParamValue();
    return res;
}
//# sourceMappingURL=seq-helper.js.map